// src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { app } from './Components/firebase';
import Signup from './Components/Signup/signup';
import Login from './Components/Login/login';
import Home from './Components/home';
import Sidebar from './Components/Sidebar/sidebar';
import Contact from "./Components/Contact/contact";
import Header from "./Components/Header/header";
import Search from "./Components/search/Search";
import AboutUs from "./Components/aboutus/Aboutus";
import Bookmark from "./Components/Bookmark/bookmark";
import Bookmarks from "./Components/Bookmark/fav";
import ScholarshipPost from './Components/scholarship/scholarship';
import ViewScholarships from './Components/scholarship/viewscholarship';
import Footer from "./Components/footer/footer";
import Footer1 from "./Components/footer/footer1";
import TermsPage from "./Components/footer/term";
import "./App.css";
import PrivacyPage from "./Components/footer/privacy";
import Viewmessage from "./Components/scholarship/viewmessage";
const auth = getAuth(app);

function App() {
    const [user, setUser] = useState(null);
    const [theme, setTheme] = useState('dark','light');
    const [isDarkMode, setIsDarkMode] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const handleLogin = (loggedInUser) => {
        setUser(loggedInUser);
    };

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (loggedInUser) => {
            setUser(loggedInUser);
            setIsLoading(false); // Set loading to false after authentication check
        });

        // Simulate loading with a delay (remove this in production)
        setTimeout(() => {
            setIsLoading(false); // Set loading to false after 2 seconds
        }, 2000);

        return () => {
            unsubscribe();
        };
    }, []);

    const toggleTheme = () => {
        setIsDarkMode(prevMode => !prevMode);
        setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }
    return (
        <div className={`App ${theme}`}>
            <Router>
                <Routes>
                    <Route
                        path="/"
                        element={
                            user ? (
                                <>
                                    <Header toggleTheme={toggleTheme} />
                                    <Sidebar isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                                    <Home  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                                    <Footer  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                                </>
                            ) : (
                                <>
                                    <Header theme={theme} toggleTheme={toggleTheme}/>
                                    <Signup isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                                    <Footer1  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                                </>
                            )
                        }
                    />

                    <Route
                        path="/login"

                        element={<>
                               <Header theme={theme} toggleTheme={toggleTheme} />
                            <Login onLogin={handleLogin} isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                            <Footer1  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                        </>}
                    />
                    <Route
                        path="/viewmessage"

                        element={<>
                            <Header theme={theme} toggleTheme={toggleTheme} />
                            <Viewmessage onLogin={handleLogin} isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>

                            <Footer1  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                        </>}
                    />
                    <Route
                        path="/term"

                        element={<>
                            <Header theme={theme} toggleTheme={toggleTheme} />
                            <TermsPage onLogin={handleLogin} isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                            <Footer1  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                        </>}
                    />
                    <Route
                        path="/privacy"

                        element={<>
                            <Header theme={theme} toggleTheme={toggleTheme} />
                            <PrivacyPage onLogin={handleLogin} isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                            <Footer1  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                        </>}
                    />
                    <Route
                        path="/scholarship"
                        element={
                            <>
                                <Header theme={theme} toggleTheme={toggleTheme} />
                                <Sidebar isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                                <ScholarshipPost isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                            </>
                        }
                    />
                    <Route
                        path="/viewscholarship"
                        element={
                            <>
                                <Header theme={theme} toggleTheme={toggleTheme}/>
                                <Sidebar isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                                <ViewScholarships isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                            </>
                        }
                    />
                    <Route
                        path="/aboutus"
                        element={
                            <>
                                <Header theme={theme} toggleTheme={toggleTheme}/>
                                <AboutUs  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                                <Footer1  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                            </>
                        }
                    />
                    {user ? (
                        <>
                            <Route
                                path="/"
                                element={
                                    <>
                                        <Header toggleTheme={toggleTheme} />
                                        <Sidebar isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                                        <Home  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                                        <Footer  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                                    </>
                                }
                            />
                            <Route
                                path="/contact"
                                element={
                                    <>
                                        <Header  theme={theme} toggleTheme={toggleTheme}/>
                                        <Sidebar  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                                        <Contact   isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                                        <Footer  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                                    </>
                                }
                            />
                            <Route
                                path="/search"
                                element={
                                    <>
                                        <Header  theme={theme} toggleTheme={toggleTheme}/>
                                        <Sidebar  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                                        <Search   isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                                        <Footer  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                                    </>
                                }
                            />
                            <Route
                                path="/bookmark"
                                element={
                                    <>
                                        <Header  theme={theme} toggleTheme={toggleTheme}/>
                                        <Sidebar  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                                        <Bookmark   isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>
                                        <Footer  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                                    </>
                                }
                            />
                            <Route
                                path="/fav"
                                element={
                                    <>
                                        <Header />
                                        <Sidebar />
                                        <Bookmarks />
                                        <Footer  isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
                                    </>
                                }
                            />
                        </>
                    ) : (
                        <Route path="/login" element={<Navigate to="/login" theme={theme} toggleTheme={toggleTheme}  />} />

                    )}
                </Routes>
            </Router>
        </div>
    );
}

export default App;
